<template>
  <div class="w-100">
    <p class="mb-3" :class="isCombine ? 'body-1-4' : 'body-2-4'">{{ title }}</p>
    <template v-if="isPromoFormVisible">
      <div class="d-flex">
        <div class="w-100 border-secondary-t radius-6 position-relative d-flex" :class="errorMessage != '' ? 'shake-el border-danger' : ''" style="padding-block: 6px;">
          <input :disabled="isApplyingPromo" type="text" class="w-100 no-focus-border border-none body-2-4 radius-6 text-ticket pl-3 pr-5" v-model="promoCode" @keyup.enter="$refs.btn_promo.handleClick()">
          <div v-if="promoCode != ''" class="position-absolute cursor-pointer lh-1" @click="clearPromoCodeInput" style="top: 8px;right:10px;">
            <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.221622 13.3683C0.521384 13.6596 1.01813 13.6596 1.30933 13.3683L6.7907 7.88694L12.2721 13.3683C12.5633 13.6596 13.0686 13.6681 13.3598 13.3683C13.651 13.0686 13.651 12.5804 13.3598 12.2892L7.87841 6.79924L13.3598 1.31787C13.651 1.02667 13.6596 0.529924 13.3598 0.238726C13.06 -0.0610364 12.5633 -0.0610364 12.2721 0.238726L6.7907 5.7201L1.30933 0.238726C1.01813 -0.0610364 0.512819 -0.069601 0.221622 0.238726C-0.0695761 0.538488 -0.0695761 1.02667 0.221622 1.31787L5.70299 6.79924L0.221622 12.2892C-0.0695761 12.5804 -0.078141 13.0771 0.221622 13.3683Z"
                fill="#777777" />
            </svg>
          </div>
        </div>
        <div class="flex-0 ml-3">
          <state-button ref="btn_promo" class="radius-6i" variant="primary" :click="applyPromoCodeToOrder" size="md"><span class="text-uppercase overline text-white">{{ $t('ticket.apply') }}</span></state-button>
        </div>
      </div>
      <p class="body-3-3 mb-0 text-danger mt-1" v-if="errorMessage">{{errorMessage}}</p>
    </template>
    <template v-else>
      <div class="w-100 d-flex align-items-center justify-content-between border-2-form-dashed radius-12 bg-light mb-3">
        <div class="w-100 p-3">
          <p class="mb-0 body-2-4">{{ appliedPromotion.name }}</p>
          <p class="mb-2 body-3">{{ appliedPromotion.detailFormula }}</p>
          <p class="mb-0 body-3 text-danger cursor-pointer" @click="showRemovePromoConfirmation()">Remove</p>
        </div>
        <div class="p-3">
          <div class="d-flex align-items-center bg-green radius-12" style="width: 100px;height: 75px;">
            <div class="w-100 text-center">
              <div class="d-flex align-items-end justify-content-center">
                <h1 class="text-white font-poppins-bold mb-0 text-34">{{ appliedPromotion.formulaText.value }}</h1>
                <p class="text-white mb-0 body-1-4 mb-1">{{ appliedPromotion.formulaText.unit }}</p>
              </div>
              <p class="text-white mb-0 body-3 mb-0" style="margin-top: -5px">Discount</p>
            </div>
          </div>
        </div>
      </div>
      <p class="mx-auto mb-0 body-3 text-green cursor-pointer d-table" @click="showRemovePromoConfirmation">Use another promo code?</p>
    </template>

    <popupConfirmation 
      :show="popupConfirmation.show" 
      :title="popupConfirmation.title" 
      :subtitle="popupConfirmation.subtitle" 
      @hide="setConfirmationModal"
      @apply="handleConfirmRemovePromo" />
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';
  import moment from 'moment';
  import { get } from '@/services/index.js'
  import popupConfirmation from '../../../general/popupConfirmation.vue';

  export default {
    props:{
      isCombine:{
        type: Boolean,
        default: false
      }
    },
    components:{
      popupConfirmation
    },
    data(){
      return {
        promoCodeInput: "",
        errorMessage: "",
        isApplyingPromo: false,
        isPromoFormVisible: true,
        popupConfirmation: {
          show: false,
          title: '',
          subtitle: ''
        }
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getBeCartAddtService',
        'getActivityTrxProducts',
        'getOutletTrxProducts',
        'getVoucherOrder',
        'getAdditionalServicePromotion'
      ]),
      title(){
        if(!this.isCombine){
          return this.$isEmpty(this.appliedPromotion) ? 'Promo Code' :'Applied Promo Code'
        }else{
          return this.$isEmpty(this.appliedPromotion) ? 'Promo code for additional product only' :'Applied promo code for additional product only'
        }
      },
      promoCode: {
        get(){return this.promoCodeInput},
        set(newValue) {
          this.promoCodeInput = newValue.toUpperCase()
        }
      },
      promoCandidateProducts(){
        let list = [];
        
        const setList = ({
          type, id, name, product_merchant_pos, detail,
          qty = null, 
          date = null, 
          variants = null, 
          product_type = "",
          isPromoMatch = false
        }) => {
          const selectedPos = product_merchant_pos.find(pos => this.$isNotEmptyV2(pos.is_active) && pos.is_active);
          if(!selectedPos) return;
          
          list.push({ 
            type, id, name, qty, date, variants, detail, product_type, isPromoMatch,
            pos: selectedPos 
          })
        } 
        
        const checkPromotion = (promotion) => {
          if(this.$isEmpty(this.getAdditionalServicePromotion) || this.$isEmpty(promotion)) return false;
          return promotion.promo_code === this.getAdditionalServicePromotion.promo_code
        }
        
        // SPA/ACTIVITY
        this.getActivityTrxProducts.forEach(activity=>{
          const { original_data: {id, name, product_merchant_pos, product_type, promotion_affected}, service_date, qty } = activity; 
          
          setList({
            type: 'ACTIVITY', id, name, product_merchant_pos, qty, product_type,
            date: service_date, 
            detail: activity,
            isPromoMatch: checkPromotion(promotion_affected.best)
          });
        })
        
        // OUTLET
        this.getOutletTrxProducts.forEach(outlet=>{
          let { product_data: {id, name, product_merchant_pos, promotion_affected = null}, variants } = outlet;

          const isVariant = variants.length > 0;
          const isPromoMatch = isVariant ? 
            variants.some(variant => checkPromotion(variant.variant_data.promotion_affected.best)) :
            checkPromotion(promotion_affected.best);
          
          setList({type: 'OUTLET', id, name, product_merchant_pos, variants, detail: outlet, isPromoMatch});
        })

        // OUTLET
        this.getVoucherOrder.cart.forEach(voucher_parent=>{
          voucher_parent.product.forEach(voucher=>{
            let { id, name, product_merchant_pos, promotion_affected = { best: null } } = voucher.data;

            const isVariant = voucher.variant_list.length > 0;
            const isPromoMatch = isVariant ? 
              voucher.variant_list.some(variant => checkPromotion(variant.data.promotion_affected.best)) :
              checkPromotion(promotion_affected.best);
            
            setList({type: 'VOUCHER', id, name, product_merchant_pos, variants: voucher.variant_list, detail: voucher, isPromoMatch});
          })
        })
        
        return list;
      },
      matchedProductCount(){
        if(this.$isEmpty(this.promoCandidateProducts)) return 0;
        return this.promoCandidateProducts.filter(product => product.isPromoMatch).length;
      },
      appliedPromotion(){
        return this.getAdditionalServicePromotion;
      }
    },
    watch:{
      promoCode(){
        if(this.$isNotEmptyV2(this.errorMessage)){
          setTimeout(() => {
            this.errorMessage = ""
          }, 1000);
        }
      },
      matchedProductCount(){
        this.removeCurrentPromo()
      }
    },
    destroyed(){
      this.removeCurrentPromo()
    },
    mounted(){
      this.updatePromoFormVisibility();
    },
    methods:{ 
      ...mapMutations([
        'updateTrxActivityProductPricing', 
        'setAdditionalServicePromotion', 
        'updateTrxOutletProductPricing', 
        'restoreTrxOutletPricePerProduct',
        'setSpecificVoucherOrder',
        'resetSpecificVoucherOrder'
      ]),
      removeCurrentPromo(){
        if((this.matchedProductCount === 0 && this.$isNotEmptyV2(this.getAdditionalServicePromotion)) || this.promoCandidateProducts.length === 0){
          this.setAdditionalServicePromotion(null)
          this.isPromoFormVisible = true
          this.promoCodeInput = ""
        }
      },
      updatePromoFormVisibility(){ 
        this.isPromoFormVisible = this.$isEmpty(this.appliedPromotion)
      },
      clearPromoCodeInput(){
        this.promoCode = "";
        this.removeAppliedPromo()
      },
      async removeAppliedPromo(){
        if(this.isApplyingPromo) return Promise.resolve();
        try {
          this.isApplyingPromo = true
          for(const product of this.promoCandidateProducts){
            const { type } = product;  
            
            if(type === 'ACTIVITY'){
              const apiResponse = await this.fetchProductDetail(product, false);
              if(!apiResponse) continue;
              this.applyPromotionToSavedProduct(product, apiResponse);
            }

            if(type === 'OUTLET'){
              this.restoreOutletOriginalPrice(product);
            }

            if(type === 'VOUCHER'){
              this.applyPromotionToSavedProduct(product, null, false);
            }
          }
        } catch (error) {
          this.errorMessage = error.message;
        } finally {
          this.isApplyingPromo = false
          return Promise.resolve();
        }
      },
      async applyPromoCodeToOrder(){
        if(this.isApplyingPromo) return Promise.resolve();
        let totalAffected = 0;
        try {
          this.isApplyingPromo = true
          for(const product of this.promoCandidateProducts){
            const apiResponse = await this.fetchProductDetail(product);
            if(!apiResponse) continue;
            
            this.applyPromotionToSavedProduct(product, apiResponse);
            
            if(totalAffected === 0 && this.isPromoApplicableToProduct(apiResponse, product.variants)) totalAffected++
          }

          if(totalAffected > 0) this.persistPromoDetailToStore();
          
        } catch (error) {
          this.errorMessage = error.message;
        } finally {
          this.isApplyingPromo = false
          
          if(totalAffected === 0 && this.$isEmpty(this.errorMessage)) this.errorMessage = 'Sorry, this promo has no effect on the product you chose'
          return Promise.resolve();
        }
      },
      isPromoApplicableToProduct(productDetail,variants=null){
        const isProductVariant = this.$isNotEmptyV2(productDetail.variant_list) && this.$isNotEmptyV2(variants);
        if(!isProductVariant) return this.validatePromoCodeMatch(productDetail);
        
        return variants.some(variant => {
          return productDetail.variant_list.some(variantApi => {
            const variantId = this.$isEmpty(variant.variant_data) ? variant.data.id : variant.variant_data.id
            const isMatchId = variantApi.id === variantId;
            return this.validatePromoCodeMatch(variantApi) && isMatchId;
          })
        })
      },
      validatePromoCodeMatch(productDetail){
        const { promotion_affected: promotion = null } = productDetail
        const isEmptyPromo = this.$isEmpty(promotion)
        const isEmptyPromoBest = this.$isEmpty(promotion.best)
        if(isEmptyPromo || isEmptyPromoBest) return false;
        
        const isPromoCodeType = promotion.best.promotion_type	=== 'PROMO_CODE';
        if(!isPromoCodeType) return false;

        return promotion.best.promo_code === this.promoCode
      },
      showRemovePromoConfirmation(){
        const { name } = this.appliedPromotion;
        this.setConfirmationModal({
          show: true,
          title: 'Removing Promo Code',
          subtitle: `Remove <b>"${name}"</b>? Re-enter the code to get your discount back.`
        })
      },
      async handleConfirmRemovePromo(){
        await this.removeAppliedPromo()
        this.setAdditionalServicePromotion(null);
        this.isPromoFormVisible = true
        this.promoCodeInput = ""
        this.setConfirmationModal()
      },
      async persistPromoDetailToStore(){
        try {
          const promotionDetail = await this.fetchPromoDetail();
          const promotionDetailDisplay = this.buildPromoDisplayText(promotionDetail);
          this.setAdditionalServicePromotion(promotionDetailDisplay);
          this.isPromoFormVisible = false
        } catch (error) {
          throw error;
        }
      },
      async fetchPromoDetail(){
        try {
          const apiParams = {
            merchant_id: this.getMerchant.id,
            promo_code: this.promoCode
          }

          const apiResponse = await get("CORE_HOTEL", "merchant-pos/promocode-detail", apiParams);
          const { success, message, data } = apiResponse.data;
          if(!success) throw new Error(message);
          
          return data;
        } catch (error) {
          throw error;
        }
      },
      buildPromoDisplayText(detailPromo){
        const { value_type, value } = detailPromo.formula[0];
        const discount = value_type === 'PERCENT' ? `${value}%` : this.$formatCurrency(value);
        const detailFormula = `Exclusive ${discount} Discount on Selected Products`
        const formulaText = () => {
          if(value_type === 'PERCENT') return { value, unit: "%" } 
          const { number, compact } = this.$formatCurrencyCompactParts(value);
          return {
            value: number,
            unit: compact
          }
        };
        return {
          ...detailPromo,
          detailFormula,
          formulaText: formulaText()
        }
      },
      async fetchProductDetail(productData, withPromoCode = true){
        try {
          const {id, pos: {id: posId}, qty = null, date = null, product_type} = productData;
          
          let params = {merchant_id: this.getMerchant.id}

          if(qty) params.qty = qty
          if(date) params.date = moment(date).format("YYYY-MM-DD");
          if(this.promoCode && withPromoCode) params.promo_code = this.promoCode

          const isProductSpa = product_type === 'concierge-spa'
          const apiPath = isProductSpa ? `spa/product/${id}` : `merchant-pos/${posId}/product/${id}`;
          const apiModule = isProductSpa ? 'CONCIERGE' : 'CORE_HOTEL';
          
          const apiResponse = await get(apiModule, apiPath, params);
          const {success, data, message} = apiResponse.data; 
          if(!success) throw new Error(message);
          ;

          return data;
        } catch (error) {
          if(error.message === 'promo_code not found') throw new Error("Promo Code not found");
          return null
        }
      },
      applyPromotionToSavedProduct(savedProduct, productWithPromoCode, isApplyPromo = true){
        const { type, detail } = savedProduct
        
        if(type === 'ACTIVITY') this.applyPromotionToActivityProduct(savedProduct, productWithPromoCode);
        if(type === 'OUTLET') this.applyPromotionToOutletProduct(savedProduct, productWithPromoCode);
        if(type === 'VOUCHER') this.updateVoucherOrderForProduct(savedProduct, productWithPromoCode, isApplyPromo);

      },
      applyPromotionToActivityProduct(savedProduct, productWithPromoCode){
        const { qty, service_time, service_date: date, place_choice: place, therapist_gender: gender } = savedProduct.detail
        
        const getPricing = (price) => {
          const getNewPrice = (key) => price[key] * Number(qty)
          const calculatePromotion = (base_price,promotion_pct) => {
            const promotionAmount = base_price*(promotion_pct/100)
            return base_price-promotionAmount
          }
          let pricing_data = {
            final: getNewPrice('price_sell_final_with_tax_service'),
            base: getNewPrice('price_sell'),
            promotion_amount: getNewPrice('promotion_amount'),
            promotion_pct: price.promotion_pct,
            taxes: getNewPrice('tax_amount'),
            services: getNewPrice('service_amount'),
            source: price
          }
          pricing_data.promotion_pct = this.$getPercentage(pricing_data.base,pricing_data.promotion_amount)

          const isPromotionZero = Math.round(price.promotion_pct) == 0;
          pricing_data.display = {
            base: pricing_data.base,
            final: isPromotionZero ? pricing_data.base : calculatePromotion(price.price_sell, Math.round(price.promotion_pct))*qty,
            promotion_pct: Math.round(price.promotion_pct)
          }
          
          return pricing_data;
        }

        let adjustmentProduct = productWithPromoCode;
        productWithPromoCode.product_merchant_pos = savedProduct.detail.original_data.product_merchant_pos;
        
        let savedProductParams = {
          product: adjustmentProduct,
          qty, date, place, gender,
          time: {},
          base_price: {}
        }

        if(this.$isEmpty(service_time.id)){
          savedProductParams.time = service_time
          savedProductParams.base_price = getPricing(productWithPromoCode.price)
        }else{
          const newScheduleList = productWithPromoCode.schedule
          const newScheduleIndex = newScheduleList.findIndex(schedule => schedule.id === service_time.id)
          
          if(newScheduleIndex != -1){
            const newSchedule = newScheduleList[newScheduleIndex]
            savedProductParams.time = newSchedule
            savedProductParams.base_price = getPricing(newSchedule.price)
          }
        }
        this.updateTrxActivityProductPricing(savedProductParams)
      },
      applyPromotionToOutletProduct(savedProduct, productWithPromoCode){
        const { variants } = savedProduct.detail
        const isVariant = this.$isNotEmptyV2(variants);
        
        let adjustmentProduct = productWithPromoCode;
        productWithPromoCode.product_merchant_pos = savedProduct.detail.product_data.product_merchant_pos;
        
        if(isVariant){
          variants.forEach(savedVariant => {
            const selectedVariant = productWithPromoCode.variant_list.find(v => v.id === savedVariant.variant_data.id);
            
            this.updateTrxOutletProductPricing({
              product: adjustmentProduct,
              variant: selectedVariant
            })
          })
        }else{
          this.updateTrxOutletProductPricing({
            product: adjustmentProduct,
            variant: {}
          })
        }
      },
      restoreOutletOriginalPrice(savedProduct){
        const { variants, detail: { product_data }  } = savedProduct
        const isVariant = this.$isNotEmptyV2(variants);

        let params = {
          product: product_data,
          variant: {},
          action: 'restore'
        }
        
        if(!isVariant){
          this.restoreTrxOutletPricePerProduct(params);
          return;
        }
        
        variants.forEach(variant => {
          params.variant = {}
          params.variant = variant.variant_data
          this.restoreTrxOutletPricePerProduct(params);
        })
        
      },
      updateVoucherOrderForProduct(savedProduct, productWithPromoCode, isApplyPromo = true){
        const { data: { merchant_pos, id: productId }, variant_list } = savedProduct.detail
        const isVariant = this.$isNotEmptyV2(variant_list);
        
        let params = {
          merchant_pos_id: merchant_pos.id,
          index_product: -1,
          is_variant: isVariant,
          index_variant: -1,
          data: {}
        }

        const posIndex = this.getVoucherOrder.cart.findIndex(pos => pos.pos.id === merchant_pos.id);
        if(posIndex === -1) return;

        const selectedPos = this.getVoucherOrder.cart[posIndex];
        
        const productIndex = selectedPos.product.findIndex(product => product.data.id === productId);

        if(productIndex === -1) return;
        params.index_product = productIndex;

        if(!isVariant){  
          if(isApplyPromo) {
            params.data = productWithPromoCode;
            params.data.product_merchant_pos = savedProduct.detail.data.product_merchant_pos;
            params.data.merchant_pos = merchant_pos;

            this.setSpecificVoucherOrder(params)
          } else {
            this.resetSpecificVoucherOrder(params)
          }
          return;
        }

        variant_list.forEach((variant, index) => {
          params.index_variant = index;
          if(!isApplyPromo){
            this.resetSpecificVoucherOrder(params)
          }else{
            const variantApiIndex = productWithPromoCode.variant_list.findIndex(variantApi => variantApi.id === variant.data.id);
            
            if(variantApiIndex !== -1){
              params.index_variant = index;
              params.data = productWithPromoCode.variant_list[variantApiIndex];
              this.setSpecificVoucherOrder(params);
            }
          }
          
        })
        
      },
      setConfirmationModal(data = {show: false, title: '', subtitle: ''}){
        this.popupConfirmation = data
      }
    
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/additionalService/PromoCode.vue